const getFirstInvalidField = (state, formGroupNames)=>{
    let fieldName1 = '';
    formGroupNames.find((groupName)=>{
        var _groupName;
        const invalidField = Object.keys((_groupName = state[groupName]) !== null && _groupName !== void 0 ? _groupName : {}).find((fieldName)=>{
            var ref;
            return !((ref = state[groupName][fieldName]) === null || ref === void 0 ? void 0 : ref.isValid);
        });
        if (invalidField) {
            fieldName1 = invalidField;
            return true;
        }
        return false;
    });
    return fieldName1;
};

export { getFirstInvalidField };
//# sourceMappingURL=get-first-invalid-field.js.map
